import { Component, OnChanges, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';

import { Menu } from '../shared/menu/menu.model';
import { FullMenuService } from './full-menu.service';
import { MenuParameters } from './menu-parameters.model';
import { UtilService } from '@app/shared/utils';


@Component({
  selector: 'app-full-menu',
  templateUrl: './full-menu.component.html',
  styleUrls: ['./full-menu.component.css']
})
export class FullMenuComponent implements OnInit, OnChanges {

  menu: Menu;
  menuCategoryName: string;
  menuDescription: string;
  menuName: string;
  translationKey: string;
  menuTabIndex: number;  

  private menu$: Observable<MenuParameters>;

  constructor(private activeRoute: ActivatedRoute, private fullMenuService: FullMenuService, private util: UtilService) { }

  ngOnInit() {

    this.menu$ = this.fullMenuService.filterMenuThroughURLParameters(this.activeRoute);
    this.menu$.subscribe((menuParameters: MenuParameters) => {
      this.assignMenuProperties(menuParameters);
    });

    this.fullMenuService.getMenuTabindex().subscribe( (menuTabIndex: number) => {      
      this.menuTabIndex = menuTabIndex;
      setTimeout(() => { 
        this.util.requestFocusOnFirstOcurrence('menu-suboption-card');
      },100);        
    })

    this.fullMenuService.getSelectedTranslationKeyCategory().subscribe( (selectedTranslationKeyCategory: string) => {           
      let classToFind = 'menu-suboption-card'
      if(selectedTranslationKeyCategory.length>0 !=undefined && selectedTranslationKeyCategory.length>0){
        classToFind += " link_"+selectedTranslationKeyCategory;
      } 
      setTimeout(() => { 
        this.util.requestFocusOnFirstOcurrence(classToFind);
      },100);        
    })
  }

  ngOnChanges() {

    this.menu$.subscribe((menuParameters: MenuParameters) => {
      this.assignMenuProperties(menuParameters);
    });
  }

  private assignMenuProperties(menuParameters: MenuParameters): void {
    this.menuCategoryName = menuParameters.category;
    this.menuName = menuParameters.name;
    this.menu = menuParameters.menu;
    if (this.menu)
      this.menuDescription = menuParameters.menu.description;
    if (this.menu)
      this.translationKey = menuParameters.menu.translationKey;
  }
}
